export default {
    lang: {
        name: 'Previously owned'
    }
}